import MetaApiService from 'core/api/meta/meta-api.service';
import { useEffect } from 'react';
import SharedButton from 'shared/components/buttons/button';
import { useDialog } from 'core/providers/DialogProvider';
import PageHeader from 'shared/components/page-header/page-header';
import { useSharedData } from 'core/providers/SharedDataProvider';
import EditUnsuccessfulJobReasonsDialog from './edit-unsuccessful-job-reasons-dialog';

const TransportSettings = () => {
  const dialog = useDialog();
  const { deliveryMeta: meta } = useSharedData();

  useEffect(() => {
    if (!meta?.unsuccessfulJobReasons) {
      MetaApiService.update('deliveries', {
        unsuccessfulJobReasons: [
          {
            key: 'Other',
            name: 'Other',
          },
        ],
      });
    }
  }, [meta?.unsuccessfulJobReasons]);

  return (
    <>
      <PageHeader title='Transport settings' />
      <div className='grid grid-cols-1 gap-6 mt-6 h-max'>
        <div className='bg-white w-full rounded-md shadow-md h-fit'>
          <div className='flex items-center p-4 border-b justify-between'>
            <p className='headline-05'>Unsuccessful job reasons</p>
            <SharedButton
              onClick={() =>
                dialog?.openDialog(<EditUnsuccessfulJobReasonsDialog reasons={meta?.unsuccessfulJobReasons ?? []} />)
              }
              type='button'
              appearance='primary'
              label='Edit'
            />
          </div>
          {meta?.unsuccessfulJobReasons?.map((reason) => (
            <div key={reason.key} className='border-b last:border-0 p-4'>
              <p>{reason.name}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TransportSettings;
